function PlansSection() {
  const { SectionEyebrow } = window.AppComponents;
  const { plans } = window.AppData.siteContent;

  return (
    <section id="plans" className="py-9">
      <div className="mb-7 max-w-3xl">
        <SectionEyebrow>Featured plans</SectionEyebrow>
        <h2 className="mt-4 font-display text-4xl font-bold tracking-[-0.05em] text-ink md:text-5xl">
          Shortlisted bundles customers love this season
        </h2>
      </div>

      <div className="grid gap-5 lg:grid-cols-3">
        {plans.map((plan) => (
          <article
            key={plan.title}
            className="rounded-[26px] border border-white/80 bg-white/80 p-6 shadow-glow backdrop-blur-xl"
          >
            <p className="inline-flex rounded-full bg-peach/12 px-3 py-2 text-xs font-extrabold uppercase tracking-[0.16em] text-coral">
              Recommended
            </p>
            <h3 className="mt-4 text-2xl font-bold">{plan.title}</h3>
            <p className="mt-3 font-display text-3xl font-bold">{plan.price}</p>
            <p className="mt-3 leading-7 text-slate-500">{plan.blurb}</p>
            <ul className="mt-5 grid gap-3">
              {plan.features.map((feature) => (
                <li key={feature} className="flex items-center gap-3">
                  <span className="h-2.5 w-2.5 rounded-full bg-gradient-to-br from-mint to-emerald-500"></span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <a
                href="/buy-now"
                className="rounded-full bg-ink px-5 py-3 font-semibold text-white shadow-[0_14px_28px_rgba(20,48,74,0.2)] transition hover:-translate-y-0.5"
              >
                Buy Now
              </a>
              <button className="rounded-full bg-gradient-to-br from-peach to-coral px-5 py-3 font-semibold text-white shadow-[0_14px_28px_rgba(225,95,56,0.26)] transition hover:-translate-y-0.5">
                Get Quote
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.PlansSection = PlansSection;
